<template>
  <div class="firebase-notification-list-container">
    <el-row>
      <el-table
        :data="firebaseMessageList"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        v-loading="listLoading"
        style="width: 100%;">
        <el-table-column
          prop="created_at"
          label="發送時間"
          width="150">
          <template slot-scope="scope">
            <span>{{ scope.row | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="platform"
          label="平台"
          min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.platform.join('、') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="debug"
          label="測試OR正式"
          min-width="50">
          <template slot-scope="scope">
            <span>{{ scope.row.debug ? '測試' : '正式' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="標題"
          width="250">
          <template slot-scope="scope">
            <span class="message-title">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="message"
          label="內容"
          min-width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    <el-dialog
      title="新增推播"
      :visible.sync="firebaseDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <el-form v-if="firebaseMessageData" :rules="firebaseMessageRules" ref="firebaseForm" :model="firebaseMessageData" label-width="80px" label-position="left">
        <el-form-item label="標題">
          <el-input v-model="firebaseMessageData.title"></el-input>
        </el-form-item>
        <el-form-item label="內容" prop="message">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5 }"
            v-model="firebaseMessageData.message"></el-input>
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-checkbox-group v-model="firebaseMessageData.platform">
            <el-checkbox label="iOS"></el-checkbox>
            <el-checkbox label="Android"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="測試" prop="debug">
          <el-checkbox v-model="firebaseMessageData.debug" label="是否為測試"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            class="tfam-button"
            v-loading.fullscreen.lock="fullLoading"
            plain
            @click="handleSubmitUpdate">儲存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchFirebaseMessageList, createFirebaseMessage } from "../../api/firebaseMessage";
  import { parseTime } from '../../utils'

  export default {
    name: "FirebaseNotificationList",
    components: {
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    data() {
      return {
        firebaseMessageList: [],
        firebaseMessageData: undefined,
        firebaseDialogVisible: false,
        listLoading: false,
        fullLoading: false,
        firebaseMessageRules: {
          message: [
            {required: true, message: '內容一定要填', trigger: 'blur'},
          ],
          platform: [
            { type: 'array', required: true, message: '請至少選擇一種平台', trigger: 'change' }
          ]
        }
      }
    },
    filters: {
      timeFilter: function (row) {
        return parseTime(row['created_at'], '{y}/{m}/{d} {h}:{i}')
      },
    },
    mounted() {
      this.getMessages()
    },
    methods: {
      getMessages() {
        const filter = {
          order: 'created_at DESC',
          limit: 10
        };
        this.listLoading = true;
        fetchFirebaseMessageList(filter).then(response => {
          this.listLoading = false;
          this.firebaseMessageList = response.data;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      createNew() {
        this.firebaseDialogVisible = true;
        this.firebaseMessageData = {
          title: undefined,
          message: undefined,
          platform: ['iOS', 'Android'],
          debug: false
        }
      },
      handleSubmitUpdate() {
        this.$refs['firebaseForm'].validate((valid) => {
          if (valid) {
            this.submitUpdate();
          } else {
            return false;
          }
        });
      },
      submitUpdate() {
        this.fullLoading = true;
        this.asyncSubmitUpdate().then(res => {
          this.fullLoading = false;
          this.$refs['firebaseForm'].resetFields();
          this.firebaseDialogVisible = false;
          this.firebaseMessageData = undefined;
          // this.firebaseMessageList.splice(0, 0, res);
          this.getMessages();
        }).catch(err => {
          this.fullLoading = false;
          // console.log(err);
          // let message = err;
          // if (err.response) {
          //   message = err.response.data.error.message + '!'
          // }
          alert('發送失敗');
        })
      },
      asyncSubmitUpdate: async function() {
        try {
          const response = await createFirebaseMessage(this.firebaseMessageData);
          return Promise.resolve(response.data);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }
  }
</script>

<style lang="scss">
  .message-title {
    cursor: pointer;
  }
  .introduction-max-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
</style>

